'use strict';

/**
 * An extension of {@see ButtonProps} that contains optional
 *   icon helpers.
 */

/**
 * {@see OwnUpIconButton} properties. An extension of the base
 *   {@see OwnUpButtonProps} which forces certain attributes
 *   to be used to support an icon-only button.
 */

/**
 * Spread this over your button to turn it into a
 *   "decorative" button. It will have all the look
 *   and feel of a button but it will not be treated
 *   as a button by screen readers. (i.e. not focusable)
 */
var decorativeButtonProps = {
  component: 'div',
  // HACK: Forces the tabIndex on the element to be unset
  tabIndex: ''
};

exports.decorativeButtonProps = decorativeButtonProps;
//# sourceMappingURL=properties-ab26fa64.js.map
